import { Icon } from 'pepsico-ds';
import { useState } from 'react';

const StoreAddressInfoItem = ({ address, storeInfo }) => {
  const [expanded, setExpanded] = useState(false);

  // If address is null, display a dash instead
  if (!address) {
    return (
      <div>
        <div className='text-xs font-normal text-gray-50'>Address</div>
        <div className='font-bold text-white'>-</div>
      </div>
    );
  }

  // Format the complete address from address object
  const formattedAddress = [
    address.addressLine1,
    address.addressLine2,
    address.city && address.stateOrProvince
      ? `${address.city}, ${address.stateOrProvince}${
          address.postalCode ? ` ${address.postalCode}` : ''
        }`
      : address.city || address.stateOrProvince || address.postalCode
      ? [address.city, address.stateOrProvince, address.postalCode]
          .filter(Boolean)
          .join(' ')
      : null,
    address.country
  ]
    .filter(Boolean)
    .join(', ');

  // Toggle expanded state
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  console.log('address', address);
  return (
    <div>
      <div className='text-xs font-normal text-gray-50'>Address</div>
      <div className='font-bold text-white'>{formattedAddress || '-'}</div>

      {expanded ? (
        <>
          <div className='mt-4 w-full'>
            <table className='w-full'>
              <tbody>
                <tr>
                  <td className='py-2'>Default</td>
                  <td className='py-2'>{address?.isDefault ? 'Yes' : 'No'}</td>
                  <td className='py-2'>ID</td>
                  <td className='py-2 text-right'>
                    {address?.addressId || '-'}
                  </td>
                </tr>
                <tr>
                  <td className='py-2'>Address Type</td>
                  <td className='py-2'>{address?.addressType || '-'}</td>
                  <td className='py-2'>Building Number</td>
                  <td className='py-2 text-right'>
                    {address?.buildingNumber || '-'}
                  </td>
                </tr>
                <tr>
                  <td className='py-2'>Address Line 1</td>
                  <td className='py-2'>{address?.addressLine1 || '-'}</td>
                  <td className='py-2'>Address Line 2</td>
                  <td className='py-2 text-right'>
                    {address?.addressLine2 || '-'}
                  </td>
                </tr>
                <tr>
                  <td className='py-2'>Customer District</td>
                  <td className='py-2'>{address?.district || '-'}</td>
                  <td className='py-2'>State</td>
                  <td className='py-2 text-right'>
                    {address?.stateOrProvince || '-'}
                  </td>
                </tr>
                <tr>
                  <td className='py-2'>City</td>
                  <td className='py-2'>{address?.city || '-'}</td>
                  <td className='py-2'>State or Providence Code Name</td>
                  <td className='py-2 text-right'>
                    {address?.stateOrProvinceName || '-'}
                  </td>
                </tr>
                <tr>
                  <td className='py-2'>State or Providence Code</td>
                  <td className='py-2'>
                    {address?.stateOrProvince || '-'}
                  </td>
                  <td className='py-2'>Country Name</td>
                  <td className='py-2 text-right'>
                    {address?.countryName || '-'}
                  </td>
                </tr>
                <tr>
                  <td className='py-2'>Country</td>
                  <td className='py-2'>{address?.country || '-'}</td>
                  <td className='py-2'>Postal Code</td>
                  <td className='py-2 text-right'>
                    {address?.postalCode || '-'}
                  </td>
                </tr>
                <tr>
                  <td className='py-2'>Country ISO Name</td>
                  <td className='py-2'>{address?.countryISOName || '-'}</td>
                  <td className='py-2'>Latitude</td>
                  <td className='py-2 text-right'>{address?.latitude || '-'}</td>
                </tr>
                <tr>
                  <td className='py-2'>Longitude</td>
                  <td className='py-2'>{address?.longitude || '-'}</td>
                  <td className='py-2'>Phone Number</td>
                  <td className='py-2 text-right'>
                    {address?.phoneNumber || '-'}
                  </td>
                </tr>
                <tr>
                  <td className='py-2'>Time Zone Name</td>
                  <td className='py-2'>{address?.timeZoneName || '-'}</td>
                  <td className='py-2'></td>
                  <td className='py-2 text-right'></td>
                </tr>
              </tbody>
            </table>
          </div>
          <button
            onClick={toggleExpanded}
            className='mt-2 flex items-center text-xs text-[#66A5E7]'>
            <Icon
              icon='close_fullscreen'
              size='small'
              className='!text-[14px]'
            />
            <span className='ml-1 font-bold'>Collapse Address</span>
          </button>
        </>
      ) : (
        <button
          onClick={toggleExpanded}
          className='mt-2 flex items-center text-xs text-[#66A5E7]'>
          <Icon icon='open_in_full' size='small' className='!text-[14px]' />
          <span className='ml-1 font-bold'>Expand Address</span>
        </button>
      )}
    </div>
  );
};

export default StoreAddressInfoItem;
